













import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { CategoryModel } from '@/models/category.model';

@Component({})
export default class CategoryCard extends Vue {
  @Prop({ required: true }) category!: CategoryModel;
  @Prop({ default: false }) isMobile!: boolean;

  openCategory(slug: string, id: number) {
    if (id === 18) {
      window.open('https://sustainabledevelopment.un.org/?menu=1300', '_blank');
    } else {
      this.$router.push(`/categories/${slug}`);
    }
  }
}
